// extracted by mini-css-extract-plugin
export default {"container":"NumericUpDown_container__Hdnav","numberInput":"NumericUpDown_numberInput__8WkQE","iconBtn":"NumericUpDown_iconBtn__XH0cM"};